import * as React from 'react';
import { FaMinusCircle } from 'react-icons/fa';
import './MatrixValueLabel.scss'
export default class MatrixValueLabel extends React.Component<any> {
  constructor(props) {
    super(props)
    this.state = {showMenu:true}
    this.valueChanged   = this.valueChanged.bind(this)
    this.saveValue      = this.saveValue.bind(this)
    this.deleteClicked  = this.deleteClicked.bind(this)
  }

  valueChanged(e) {
    this.props.delegate.valueChanged(e.target.value, this.props.x, this.props.y, this.props.index, false)
  }
  saveValue() {
    this.props.delegate.valueChanged(this.props.value, this.props.x, this.props.y, this.props.index, true)
  }
  deleteClicked() {
    this.props.delegate.deleteValue(this.props.x, this.props.y, this.props.index)
  }

  render() {
    let className = "MatrixValueLabel"
    let title;
    if (this.props.value === "SPECIAL_NOT_SET") {
      className += " special"
      title = <span>Not Set</span>
    } else if (this.props.value === "SPECIAL_OTHER") {
      className += " special"
      title = <span>Other</span>
    } else {
      const tabindex = (this.props.focused) ? this.props.index + 1 : -1;
      title = this.props.canEdit ? <input value={this.props.value} onChange={this.valueChanged} onBlur={this.saveValue} tabIndex={tabindex} id={this.props.inputId} autoComplete="off" /> :this.props.value
    }

    const deleteButton = (this.props.canDelete && this.props.canEdit) ? <div className="deleteButton" onClick={this.deleteClicked}><FaMinusCircle /></div> : null;

    return <div className={className}>
            {title}
            {deleteButton}
            </div>
  }
}
